import { render, staticRenderFns } from "./MenuTypeDialog.vue?vue&type=template&id=bf7b1970&scoped=true"
import script from "./MenuTypeDialog.vue?vue&type=script&lang=js"
export * from "./MenuTypeDialog.vue?vue&type=script&lang=js"
import style0 from "./MenuTypeDialog.vue?vue&type=style&index=0&id=bf7b1970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf7b1970",
  null
  
)

export default component.exports